<template>
  <v-form ref="form" v-model="validForm">
    <v-container fluid>
    <template v-if="!preview">
      <v-row align="center" v-if="!isFieldHidden('title')">
        <v-select :items="$t('participantTitles')" :label="$t('participantTitle')" v-model="participant.title"
          :rules="isFieldOptional('title')?[required]:[]" :disabled="preview"></v-select>
      </v-row>
      <v-row align="center">
        <v-select :items="participantTypes" :label="$t('participantType')" v-model="participant.participantType"
          :hint="`${$t(participantTypes.name)}`" :item-text="translateOption" item-value="id" :rules="[required]"
          :disabled="preview || disabledParticipantType">
        </v-select>
      </v-row>
      <v-row v-if="changeTypeWarning">
        <v-col>{{ $t('changeParticipantTypeWarning') }}</v-col>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('cnp')">
        <v-text-field :label="$t('participantCnp')" v-model="participant.cnp" :rules="isFieldOptional('cnp')?[cnpRule]:[required,cnpRule]"
          :disabled="preview"></v-text-field>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('cuim')">
        <v-text-field :label="$t('participantCuim')" v-model="participant.cuim" :rules="isFieldOptional('cuim')?[cuimRule]:[required, cuimRule]"
          :disabled="preview"></v-text-field>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('cuibbc')">
        <v-text-field :label="$t('participantCuibbc')" v-model="participant.cuibbc" :rules="isFieldOptional('cuibbc')?[]:[required]"
          :disabled="preview"></v-text-field>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('didactic')">
        <v-combobox :items="$t('participantDidactics')" :label="$t('participantDidactic')" v-model="participant.didactic"
          :rules="isFieldOptional('didactic')?[]:[required]" :disabled="preview"></v-combobox>
      </v-row>
      <v-row align="center">
        <v-text-field :label="$t('participantSurname')" v-model="participant.surname" :disabled="preview" :rules="[required]"></v-text-field>
      </v-row>
      <v-row align="center">
        <v-text-field :label="$t('participantName')" v-model="participant.name" :rules="[required]"
          :disabled="preview"></v-text-field>
      </v-row>
      </template>
      <v-row align="center">
        <v-text-field class="email-text-field" :label="$t('participantEmail')" v-model="participant.email"
          :disabled=" (preview && !(editEmailPreview+''=='true')) || loggedIn" :rules="[required, emailRule, emailAvailableRule]" ref="participantEmail"></v-text-field>
      </v-row>
      <v-row  align="center" v-if="emailAlreadyUsed">
        <v-col>
          <v-alert type="error">{{ $t('emailAlreadyUsed') }} <br><a @click="$emit('gotologin');">{{ $t('emailAlreadyUsedGoToLogin') }}</a></v-alert>
        </v-col>
      </v-row>
      <template v-if="!preview">
      <v-row align="center" v-if="!isFieldHidden('institution')">

        <v-text-field v-if="getFieldType('institution') == 'TEXT'" :label="$t('participantInstitution')" v-model="participant.institution" 
          :disabled="preview"></v-text-field>
        <v-select v-if="getFieldType('institution') == 'SELECT'" :items="getFieldOptions('institution')" :label="$t('participantInstitution')" v-model="participant.institution"
          :disabled="preview">
        </v-select>
        <v-combobox v-if="getFieldType('institution') == 'AUTOCOMPLETE'" :items="getFieldOptions('institution')" :label="$t('participantInstitution')"
          v-model="participant.institution" :disabled="preview"></v-combobox>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('specialisation')">
        <v-combobox :items="$t('participantSpecialisations')" :label="$t('participantSpecialisation')"
          v-model="participant.specialisation" :rules="isFieldOptional('specialisation')?[]:[required]" :disabled="preview"></v-combobox>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('department')">
        <v-text-field :label="$t('participantDepartment')" v-model="participant.department"
          :disabled="preview"></v-text-field>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('country')">
        <v-select :items="countries" :label="$t('participantCountry')" v-model="participant.country" item-text="name"
          item-value="name" :rules="isFieldOptional('country')?[]:[required]" :disabled="preview"></v-select>
      </v-row>
      <template v-if="!isFieldHidden('county')">
        <v-row align="center" v-if="participant.country == 'Romania'">
          <v-select :items="counties" :label="$t('participantCounty')" v-model="participant.county" item-text="name"
            item-value="name" :rules="isFieldOptional('county')?[]:[required]" :disabled="preview"></v-select>
        </v-row>
        <!-- non romanian region-->
        <v-row align="center" v-else>
          <v-text-field :label="$t('participantCounty')" v-model="participant.county" :rules="isFieldOptional('county')?[]:[required]"
            :disabled="preview"></v-text-field>
      </v-row>
      </template>
      <template v-if="!isFieldHidden('city')">
        <v-row align="center" v-if="participant.country == 'Romania'">
          <v-select :items="countyCities" :label="$t('participantCity')" v-model="participant.city" item-text="name"
            item-value="name" :rules="isFieldOptional('cuim')?[]:[required]" :disabled="preview"></v-select>
        </v-row>
        <!-- non romanian city-->
        <v-row align="center" v-else>
          <v-text-field :label="$t('participantCity')" v-model="participant.city" :rules="isFieldOptional('city')?[]:[required]"
            :disabled="preview"></v-text-field>
        </v-row>
      </template>

      <v-row v-if="!isFieldHidden('officePhone') || !isFieldHidden('mobile')">
        <span class="title">{{ $t("participantContactData") }}</span>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('officePhone')">
        <v-text-field :label="$t('participantOfficePhone')" v-model="participant.officePhone" :rules="[phoneRule]"
          :disabled="preview"></v-text-field>
      </v-row>
      <v-row align="center" v-if="!isFieldHidden('mobile')">
        <v-text-field :label="$t('participantMobile')" v-model="participant.mobile" :rules="isFieldOptional('mobile')?[phoneRule]:[required, phoneRule]"
          :disabled="preview"></v-text-field>
      </v-row>
    </template>
      <template  v-if="!preview && !loggedIn">
        <v-row>
          <span class="title">{{ $t("participantAccountData") }}</span>
        </v-row>
        <v-row>
          <v-checkbox class="px-2" :label="$t('showPassword')" v-model="showPassword"
           :disabled="preview">
        </v-checkbox>
        </v-row>
        <v-row align="center">
          <v-text-field :type="showPassword ? 'text': 'password'" :label="$t('participantPassword')" v-model="participant.password"
            :rules="[required, min6Pass]" :disabled="preview"></v-text-field>
        </v-row>
        <v-row align="center">
          <v-text-field :type="showPassword ? 'text': 'password'" :label="$t('participantConfirmPassword')" v-model="participant.confirmPassword"
            :rules="[required, matchingPasswords]" :disabled="preview"></v-text-field>
        </v-row>
      </template>
      <v-row v-if="!preview">
        <span class="title">{{ $t("participantDataProtectionDesc") }}</span>
      </v-row>
      <v-row v-if="!preview">
        <v-checkbox class="px-2" :label="$t('participantUseDataTerms')" v-model="participant.useDataTerms" :rules="[required]"
          :disabled="preview">
          <template v-slot:label>
            <div>
              {{ $t("participantUseDataTerms") }}
              <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <a target="_blank" href="https://eventer.ro/politica-de-confidentialitate-gdpr" v-bind="props" @click.stop>
                    https://eventer.ro/politica-de-confidentialitate-gdpr
                  </a>
                </template>
                Opens in new window
              </v-tooltip>
            </div>
          </template>
        </v-checkbox>
      </v-row>
      <v-row v-if="!preview">
        <v-checkbox class="px-2" :label="$t('participantSendDataTerms') + ' \'' + $t(evenName) + '\''" v-model="participant.sendDataTerms"
          :rules="[required]" :disabled="preview">
        </v-checkbox>
      </v-row>
      <v-row v-if="!preview">
        <v-checkbox class="px-2" :label="$t('participantSendDataTerms2')" v-model="participant.useForCongresAndInfo" :disabled="preview">
        </v-checkbox>
      </v-row>
    </v-container>
  </v-form>
</template>
  
<script>
import { participant } from "@/model/participant";
import countries from "./countries.json";
import siruta from "./siruta.json";
import { hasOkPayments } from "@/utils/utils.js";
import axios from "axios";
export default {
  emits: ['formValid'],
  props: {
    participantTypes: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
    },
    evenName: {
      type: String,
      required: true,
    },
    eventId: {
      type: String,
      required: true,
    },
    preview: {
      type: Boolean,
      required: true
    },
    loggedIn: {
      type: Boolean,
      required: false
    },
    editEmailPreview: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      validForm: false,
      participant,
      countries,
      siruta,
      showPassword : false,
      emailAlreadyUsed : false,
    };
  },
  watch: {
    "participant.country": function () {
      this.participant.county = undefined;
    },
    "participant.selectedCounty": function (newVal) {
      if (newVal) {
        this.participant.county = newVal.name;
      } else {
        this.participant.county = undefined;
      }
    },
    validForm(newVal) {
      this.$emit('formValid', newVal)
    },
  },
  computed: {
    counties() {
      return this.siruta;
    },
    countyCities() {
      let counties = [];
      this.counties.forEach((county) => {
        if (county.name == this.participant.county) {
          counties = county.children
        }
      })
      return counties
    },
    partycipantTypeObject (){
      let returnPtype ;
      this.participantTypes.forEach((ptype) => {
        if (this.participant.participantType == ptype.id) {
          returnPtype = ptype;          
        }
      });
      return returnPtype;
    },
    participantTypeHiddenFields(){
      if(this.partycipantTypeObject && this.partycipantTypeObject.hiddenFields){
        return this.partycipantTypeObject.hiddenFields.split(",");
      }
      return [];
    },
    participantTypeoptionalFields(){
      if(this.partycipantTypeObject && this.partycipantTypeObject.optionalFields){
        return this.partycipantTypeObject.optionalFields.split(",");
      }
      return [];
    },
    identityType() {      
      if(this.partycipantTypeObject){
        return this.partycipantTypeObject.identyType;
      }
      return undefined;
    },
    changeTypeWarning(){
      if((this.participant.services.selectedServices && this.participant.services.selectedServices.length > 0)
        || (this.participant.services.rooms && this.participant.rooms.selectedRooms.length > 0)
        || (this.participant.resumes && this.participant.resumes.length > 0)
      ){
        return true;
      }
      return false
    },
    disabledParticipantType(){
      return this.changeTypeWarning || hasOkPayments(this.participant);
    }
  },
  methods: {
    getFieldDefinition(fieldId){
      if(this.fields) {
        const definedField = this.fields.find(f=>{
          return f.name == fieldId
        });
        return definedField;
      }
    },
    getFieldType(fieldId) {

      const definedField = this.getFieldDefinition(fieldId);
      if(definedField) {
        return definedField.type;
      }
      return 'TEXT';
    },
    getFieldOptions(fieldId){
      const definedField = this.getFieldDefinition(fieldId);
      if(definedField) {
        const values =  definedField.values.map(v=> this.$t(v.value));
        return values;
      }
      return [];
    },
    isFieldHidden(field){
      return this.participantTypeHiddenFields.includes(field);
    },
    isFieldOptional(field){
      return this.participantTypeoptionalFields.includes(field);
    },
    translateOption(item) {
      return this.$t(`${item.name}`);
    },
    phoneRule: function (value) {
      if(!value) {
        return true;
      }
      // Regular expression pattern for email validation
      const phoneRegex =
        /^\+?[0-9]{1,3}?[\s.-]?[(]?[0-9]{1,3}[)]?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/;

      // Test the email against the pattern and return the result
      if (phoneRegex.test(value)) {
        return true;
      } else {
        return this.$t("error.phoneFormat");
      }
    },
    emailRule: function (value) {
      // Regular expression pattern for email validation
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Test the email against the pattern and return the result
      if (pattern.test(value)) {
        return true;
      } else {
        return this.$t("error.emailFormat");
      }
    },
    emailAvailableRule : async function(value){
      //valid if is not a valid email or participantalready logged in
      if(this.loggedIn || this.emailRule(value)!==true || !value){
        return true;
      }
      try {
        await axios.get(process.env.VUE_APP_BACKEND + "participant/registration/validate/"+this.eventId, 
        {params:{ email: value }});
        this.emailAlreadyUsed = false;
        return true;
      } catch (error) {
        if(error.message.includes("409")){
          this.emailAlreadyUsed = true;
          return false;
        }
        //other server error
        return true;
      }
    },
    cuimcnpRule: function (value) {
      if (this.cuimRule(value) == true || this.cnpRule(value) == true) {
        return true;
      } else {
        return this.$t("error.cuimcnpFormat");
      }
    },
    cuimRule: function (value) {
      // Check if the string is empty
      if (value === "") {
        return true;
      }

      // Check if the string contains only digits and has a length of 10
      if (/^\d{10}$/.test(value)) {
        return true;
      } else {
        return this.$t("error.cuimFormat");
      }
    },
    cnpRule: function (value) {
      // Check if the string is empty
      if (value === "") {
        return true;
      }

      // Check if the string contains only digits and has a length of 10
      if (/^\d{13}$/.test(value)) {
        return true;
      } else {
        return this.$t("error.cnpFormat");
      }
    },
    required: function (value) {
      if (value) {
        return true;
      } else {
        return this.$t("error.required");
      }
    },
    min6Pass: function (value) {
      if (value != null && value.length >= 6) {
        return true;
      } else {
        return this.$t("error.minPass");
      }
    },
    matchingPasswords: function () {
      if (this.participant.password === this.participant.confirmPassword) {
        return true;
      } else {
        return this.$t("error.passMissmatch");
      }
    },
    validate: function () {
      this.$refs.form.validate();
    }
  },
  mounted() {
    this.participantTypes.forEach(p=> {
        p.disabled = (p.maxPlaces && p.maxPlaces > 0 && p.registeredCount) ? p.registeredCount >=p.maxPlaces : false;
      //if not logged in remove the type selection if it's disabled 
        
        if(p.disabled && !this.loggedIn && p.id == this.participant.participantType){
          this.participant.participantType = undefined;
        }

      }
    );
    this.selectedParticipantType = this.participant.participantType;
  },
  created() { },
};
</script>
<style>
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea,
.theme--light.v-select .v-select__selection--disabled,
.theme--light.v-input--is-disabled,
.theme--light.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.87);
}

.v-input--is-disabled .v-input__append-inner {
  display: none;
}
</style>